import { Grid, IconButton, Paper } from "@material-ui/core";
import { IconFile, IconTrash } from "@tabler/icons-react";
interface props {
  file: File;
  onClick: (file: File) => void;
}
const FileItemPreview = ({ file, onClick }: props) => {
  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <Paper variant="outlined" style={{ padding: "5px" }}>
          <Grid
            container
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={1} sm={1}>
              <center>
                <IconFile color="#ADC4CE" />
              </center>
            </Grid>
            <Grid item xs={9} sm={9}>
              <p>{file.name}</p>
            </Grid>
            <Grid item xs={2} sm={2}>
              <center>
                <IconButton onClick={() => onClick(file)}>
                  <IconTrash color="red" />
                </IconButton>
              </center>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </>
  );
};

export default FileItemPreview;
